import { useEffect, useRef, useState } from "react";
import { uploadSrcSet, srcSetFallback } from "@/lib/imgVariants";

export const BlurImage = ({ src, alt, className = "", sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw", ...props }) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current && ref.current.complete) setLoaded(true);
  }, []);

  return (
    <div className="relative w-full h-full overflow-hidden">
      {!loaded && (
        <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-[#E5E1D8] via-[#F0EDE5] to-[#DAD5C9]" />
      )}
      <img
        ref={ref}
        src={src}
        srcSet={uploadSrcSet(src)}
        sizes={uploadSrcSet(src) ? sizes : undefined}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={(e) => { srcSetFallback(e); setLoaded(true); }}
        className={`${className} transition-[filter] duration-700 ease-out ${loaded ? "blur-0" : "blur-md"}`}
        {...props}
      />
    </div>
  );
};
